export default __webpack_public_path__ + "static/media/appStoreIcon.4b53211e.png";